import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ILicense, ILicenseAuditLog, ILicensePayload } from '../shared/interfaces/ILicense';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {
  constructor(private httpService: HttpService) { }

  getLicensesByUser(userId: number): Observable<ILicense[]> {
    return this.httpService.get(`license/user/${userId}`);
  }

  getLicenseAuditLogsByUser(userId: number): Observable<ILicenseAuditLog[]> {
    return this.httpService.get(`license/user/${userId}/audit-logs`);
  }

  getLicenseAuditLogs(params: any): Observable<any> {
    return this.httpService.get('license/audit-logs', { params });
  }

  getLicenseEmailLogs(params: any): Observable<any> {
    return this.httpService.get('license/email-logs', { params });
  }

  createLicense(payload: ILicensePayload): Observable<number> {
    return this.httpService.post('license', payload);
  }

  getMyActiveLicense(): Observable<ILicense | null> {
    return this.httpService.get('user/license');
  }

  cancelMyLicense(): Observable<number> {
    return this.httpService.post('user/license/cancel', {});
  }
}
